import React from 'react'

export default function OrderPrescription() {
  return (
    <div className='mt-10'>OrderPrescription</div>
  )
}
